import {
  DeliveryDateResponse,
  DeliveryTypeResponse,
  OrderCalculatorItemResponse,
  OrderDeliveryInfoRequest
} from 'schema'

export enum DeliveryTypeEnum {
  courier = 'courier',
  terminal = 'terminal'
}

export type TDeliveryTypeRequestData = {
  address: string
  latitude: string
  longitude: string
  customerId?: string
}

export type TDeliveryDestinationTypeRequestData = {
  address: string
  latitude: string
  longitude: string
  customerId?: string
  departureTerminalId?: string
}

export type TDeliveryTypeResponseData = NonNullable<DeliveryTypeResponse['data']>['deliveryType']

export type TDeliveryInfoDateRequest = {
  departureDate: string
  departureTerminalId: string
  destinationTerminalId: string
  type: DeliveryTypeEnum
  destinationLatitude?: string
  destinationLongitude?: string
  destinationType?: DeliveryTypeEnum
}

export type DeliveryCostRequest = OrderDeliveryInfoRequest

export type DeliveryCostResponse = NonNullable<OrderCalculatorItemResponse['data']>

export type TDeliveryInfoDateResponse = NonNullable<DeliveryDateResponse['data']>
